const CLASSROOM_TYPES = {
  FETCH_CLASSROOMS_BEGIN: "FETCH_CLASSROOMS_BEGIN",
  FETCH_CLASSROOMS_SUCCESS: "FETCH_CLASSROOMS_SUCCESS",
  FETCH_CLASSROOMS_FAILURE: "FETCH_CLASSROOMS_FAILURE",

  CREATE_CLASSROOM_BEGIN: "CREATE_CLASSROOM_BEGIN",
  CREATE_CLASSROOM_SUCCESS: "CREATE_CLASSROOM_SUCCESS",
  CREATE_CLASSROOM_FAILURE: "CREATE_CLASSROOM_FAILURE",

  UPDATE_CLASSROOM_BEGIN: "UPDATE_CLASSROOM_BEGIN",
  UPDATE_CLASSROOM_SUCCESS: "UPDATE_CLASSROOM_SUCCESS",
  UPDATE_CLASSROOM_FAILURE: "UPDATE_CLASSROOM_FAILURE",

  DELETE_CLASSROOM_BEGIN: "DELETE_CLASSROOM_BEGIN",
  DELETE_CLASSROOM_SUCCESS: "DELETE_CLASSROOM_SUCCESS",
  DELETE_CLASSROOM_FAILURE: "DELETE_CLASSROOM_FAILURE",

  SHARE_CLASSROOM_BEGIN: "SHARE_CLASSROOM_BEGIN",
  SHARE_CLASSROOM_SUCCESS: "SHARE_CLASSROOM_SUCCESS",
  SHARE_CLASSROOM_FAILURE: "SHARE_CLASSROOM_FAILURE",

  ACCEPT_CLASSROOM_BEGIN: "ACCEPT_CLASSROOM_BEGIN",
  ACCEPT_CLASSROOM_SUCCESS: "ACCEPT_CLASSROOM_SUCCESS",
  ACCEPT_CLASSROOM_FAILURE: "ACCEPT_CLASSROOM_FAILURE",

  REMOVE_ENTITY_BEGIN: "REMOVE_ENTITY_BEGIN",
  REMOVE_ENTITY_SUCCESS: "REMOVE_ENTITY_SUCCESS",
  REMOVE_ENTITY_FAILURE: "REMOVE_ENTITY_FAILURE",

  FETCH_CLASSROOM_DETAILS_BEGIN: "FETCH_CLASSROOM_DETAILS_BEGIN",
  FETCH_CLASSROOM_DETAILS_SUCCESS: "FETCH_CLASSROOM_DETAILS_SUCCESS",
  FETCH_CLASSROOM_DETAILS_FAILURE: "FETCH_CLASSROOM_DETAILS_FAILURE",
};

export default CLASSROOM_TYPES;
